"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableTranslator = void 0;
exports.tableTranslator = {
    en: {
        nameHeader: "NAME",
        actionHeader: "ACTIONS",
        onDeleteMessage: function (name) {
            return "Are you sure you want to delete ".concat(name, " ?");
        },
    },
    ru: {
        nameHeader: "ИМЯ",
        actionHeader: "ДЕЙСТВИЯ",
        onDeleteMessage: function (name) {
            return "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C ".concat(name, " ?");
        },
    },
};
